import React from 'react';
import { BUTTON_COLORS } from './GameEngine';
import './GameUI.css';

export function ScoreBar({ score, total, streak, correctInRow, levelName }) {
  return (
    <div className="score-bar">
      <div className="level-name">{levelName}</div>
      <div className="score-center">
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i} className={`progress-dot ${i < correctInRow ? 'filled' : ''}`}>
            {i < correctInRow ? '⭐' : '○'}
          </span>
        ))}
      </div>
      <div className="score-box">
        <span className="score-label">Points</span>
        <span className="score-value">{score}/{total}</span>
      </div>
    </div>
  );
}

export function ResultBanner({ showResult, isCorrect, numA, numB, correct }) {
  if (!showResult) return null;
  return (
    <div className={`result-banner ${isCorrect ? 'correct' : 'wrong'}`}>
      {isCorrect
        ? `🎉 Bravo ! ${numA} + ${numB} = ${correct}`
        : `😊 Pas tout à fait… ${numA} + ${numB} = ${correct}`}
    </div>
  );
}

export function ChoicesGrid({ choices, selected, correct, onChoice }) {
  return (
    <div className="choices-wrapper">
      <div className="choices-label">Choisis la bonne réponse !</div>
      <div className="choices-grid">
        {choices.map((choice, i) => {
          let state = 'default';
          if (selected !== null) {
            if (choice === correct) state = 'correct';
            else if (choice === selected) state = 'wrong';
            else state = 'dimmed';
          }
          return (
            <button
              key={choice}
              className={`choice-btn ${state}`}
              style={{ '--btn-color': BUTTON_COLORS[i % BUTTON_COLORS.length] }}
              onClick={() => onChoice(choice)}
              disabled={selected !== null}
            >
              {choice}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function UnlockModal({ onNext, hasNext }) {
  return (
    <div className="unlock-overlay">
      <div className="unlock-card">
        <div className="unlock-stars">⭐⭐⭐⭐⭐</div>
        <div className="unlock-title">Fantastique !</div>
        <div className="unlock-subtitle">Tu as répondu 5 fois de suite !</div>
        {hasNext ? (
          <button className="unlock-next-btn" onClick={onNext}>
            🚀 Niveau suivant !
          </button>
        ) : (
          <>
            <div className="unlock-subtitle">🏆 Tu as terminé tous les niveaux !</div>
            <button className="unlock-next-btn" onClick={onNext}>
              🔁 Recommencer !
            </button>
          </>
        )}
      </div>
    </div>
  );
}
